<template>
  <div class="event-view-cover full-page" v-if="event">
    <ui-image :src="event.cover[0]" :timeout="10000" v-if="event && event.cover" cover>
    </ui-image>
    <div class="event-share">
      <span class="pointer" @click="showPoster = true">
        <ui-icon name="weixin"></ui-icon>{{ $t("wechat") }}
      </span>
    </div>
    <div class="event-info">
      <div class="event-info-title">
        <h3>{{event.title}}</h3>
        <p v-if="event.intro">{{event.intro}}</p>
        <ui-hr></ui-hr>
        <ui-avatar v-if="!event.eventOptions.anonymous" :url="event.userInfo.avatar"></ui-avatar>
        <p v-if="!event.eventOptions.anonymous">by: {{event.userInfo.username}}</p>
        <p>{{$t('eventMemberSum',{sum:event.sum})}}</p>
        <p v-if="event.eventOptions.endDate">
          {{$t('eventCountdown')}}<ui-countdown @stop="countDownStopped('end')" :show-seconds="false" :show-ms="false" :date="new Date(event.eventOptions.endDate)"></ui-countdown>
        </p>
      </div>
      <ui-button type="ghost" full @click="addArticle" v-if="canAddArticle">{{$t('addNewArticleToEvent')}}</ui-button>
      <ui-button type="ghost" full v-if="now < new Date(event.eventOptions.openDate)">{{$t('eventOpenDateCountdown')}} <ui-countdown @stop="countDownStopped('openDate')" :show-seconds="false" :show-ms="false" :date="new Date(event.eventOptions.openDate)"></ui-countdown>
      </ui-button>
      <ui-button type="ghost" full @click="goList">{{$t('eventArticleList')}}</ui-button>
    </div>
    <div class="event-bottom-info">
      powered by unicapsule <span v-if="i18n"> - <lang-selector></lang-selector></span> <span v-if="icp"> - {{ icp }}</span>
    </div>
    <ui-modal v-model="showPoster" :show-close-icon="false" custom-class="wechat-modal" :z-index="2000">
      <poster :book="event" :link="link"></poster>
    </ui-modal>
    <ui-modal v-model="showEditor" lock custom-class="editor-modal" @after-enter="editorOpen" :z-index="2000">
      <editor mini ref="editor" @change="editorChange"></editor>
      <ui-button-group>
        <ui-button @click="saveArticle">{{$t('save')}}</ui-button>
        <ui-button type="normal" @click="showEditor = false">{{$t('cancel')}}</ui-button>
      </ui-button-group>
    </ui-modal>
  </div>
</template>
<script>
import api from "../../api/index";
import config from "../../config.js";
import LangSelector from '../../components/LangSelector.vue';
const siteConfig = config[process.env.NODE_ENV];
import { mapGetters } from "vuex";
import Poster from '../../components/poster.vue'
import Role from '../../mixin/role.js'
import Editor from '../../components/Editor.vue'

export default {
  data() {
    return {
      query: null,
      activated: false,
      showPoster: false,
      eventName: "",
      editorKey: Date.now(),
      event: null,
      now: new Date(),
      i18n: siteConfig.i18n,
      icp: siteConfig.icp,
      showEditor: false,

    };
  },
  components: {
    Poster,
    LangSelector,
    Editor
  },
  mixins: [Role],
  computed: {
    ...mapGetters(['authInfo']),
    isAuthor() {
      return this.authInfo && this.authInfo.id == this.event.authorId
    },
    canAddArticle() {
      if (this.isAdmin || this.isAuthor) {
        return true
      }
      if (!this.event.allowCoWrite) {
        return false
      } else {
        if (!this.event.eventOptions.openDate && this.isBeforeEndDate) {
          return true
        }
      }




    },
    isBeforeOpenDate() {
      return this.event.eventOptions.openDate ? this.now < new Date(this.event.eventOptions.openDate) : true
    },
    isBeforeEndDate() {
      return this.event.eventOptions.endDate ? this.now < new Date(this.event.eventOptions.endDate) : true
    },
    isBewteenOpenAndEnd() {
      return this.now > new Date(this.event.eventOptions.openDate) && this.now < new Date(this.event.eventOptions.endDate)
    },
    link() {
      return `${siteConfig.fullHost}/e/${this.event.code}`;
    }

  },
  mounted() {
    api.getEvent(this.$route.params.code).then(res => {
      this.event = res.data.event
    }).catch(err => {
      this.$UiToast.warning('Event not found')
      this.$router.push('/')
    })

  },
  methods: {
    countDownStopped() {
      this.now = new Date()
    },
    goList(){
      this.$router.push(`/event/${this.event.title}/list`)
    },
    editorChange(html) {
      localStorage.setItem(`event-editor-${this.event.title}`, html)
    },
    editorOpen() {
      let content = localStorage.getItem(`event-editor-${this.event.title}`)
      if (content) {
        this.$refs["editor"].setHtml(content);
      }
    },
    saveArticle() {
      this.$refs["editor"].getHtml().then(content => {
        api.addArticleUnconditional({ content: content, id: this.event.id }).then(res => {
          this.showEditor = false
          localStorage.removeItem(`event-editor-${this.event.title}`)
        }).catch(err => {
          this.showEditor = false
        })
      });
    },
    addArticle() {


      if (!this.event.eventOptions.needLogin && !this.authInfo) {
        this.showEditor = true

      } else {
        this.$router.push(`/event/addArticle/${this.event.id}`)

      }
    },
    clickSumButton() {
      if (this.event.eventOptions.ignoreOpenDate) {

      } else {
        if (new Date(this.event.eventOptions.openDate) > new Date()) {
          this.$UiToast.warning(this.$t('needToWaitUntilEventOpenDate'))
        }
      }
    },
    onCopy() {
      this.$UiToast({
        message: this.$t("linkCopied")
      });
    }
  }
};

</script>
<style lang="scss" scoped>
.share {
  display: inline-block;
}

</style>
